import Backbone from 'backbone';
import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import Settings from '~/settings.js';
import template from '~/templates/req2fa.handlebars';
import toastr from 'toastr';

var Req2FAView = Backbone.View.extend({
	className: 'Req2FA_wrapper',
	userId: null,
	initialize: function() {
		
	},
	
	events: {
		'click .open2fa': 'activate2FA',
	},
	
	render: function() {
		this.attachEvents();
		var handlebarsTemplate = Handlebars.template(template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.form-control').on('keypress', function(e){
			if(e.key === "Enter") {
				e.preventDefault();
				$('.open2fa').click();
			}
		});
		this.translate();
		EventHub.trigger('renderTickets');
		return this;
	},
	
	attachEvents: function() {
		var that = this;
		this.listenTo(EventHub, 'req2fauth:setData', data => {
			that.userId = data.id;
			that.$el.find('#qr-2fa').attr('src', data.url);
		});
	},
	
	translate: function(e){
		if( lang !='es'){
			this.$el.find('.item').each(function(index, element){
				$(this).text(arrlang[lang][$(this).attr("key")]);
			});
		}
	},

	activate2FA: function() {
		if(Settings.req2fa){
			var token = this.$('#token-profile').val();
			if(token != ''){
				
				var params = {
					id: this.userId,
					enabled2fa: true,
					token: token
				};

				Parse.Cloud.run("Activate2FA", params).then(function(result) {
					if(result.verified)
					{
						toastr.success(arrlang[lang]["ActivateTokenSuccess"]);
					}
					else{				
						toastr.error('Token inválido');
					}				
					
					EventHub.trigger('navigate', 'login', {
						trigger: true
					});
				},
				function(error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							toastr.error(arrlang[lang]['ActivateTokenError'],'Error');
						break;
					}
				});
			}			
		}
	},
});
export default Req2FAView;
